import { useEffect, useState } from 'react';

export const MOBILE_BREAKPOINT = 992;

export function useIsMobile(breakpoint = MOBILE_BREAKPOINT) {
    const [isMobile, setIsMobile] = useState(() => {
        if (typeof window === 'undefined') return false;
        return window.innerWidth < breakpoint;
    });

    useEffect(() => {
        const media = window.matchMedia(`(max-width: ${breakpoint - 1}px)`);
        const onChange = (event) => setIsMobile(event.matches);

        setIsMobile(media.matches);
        media.addEventListener('change', onChange);
        return () => media.removeEventListener('change', onChange);
    }, [breakpoint]);

    return isMobile;
}
